<template>
  <BaseModal class="modal-cancel" modal-id="modalCancel" :show-modal="props.showModal">
    <template #heading>Cancel reservation</template>
    <template #content>
      <div class="app-modal-basic">
        <img src="@ridmv/web-themes/images/icons/exclamation-triangle-solid.svg" alt="">
        <div>
          <p>Are you sure you want to cancel this reservation?</p>
          <p>Reservation confirmation number: <span class="code">{{ props.code }}</span></p>
          <p>Once your reservation has been cancelled, you will need to make a new reservation based on current openings.</p>
        </div>
      </div>
    </template>
    <template #footing>
      <BaseButtonGroup>
        <button type="button" @click="emit('doClose')">{{ language.btnKeepMyRes }}</button>
        <button type="submit" class="app-btn-primary"
                @click="emit('doDeleteReservation')">{{ language.btnCancelMyRes }}</button>
      </BaseButtonGroup>
     </template>
  </BaseModal>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import BaseModal from '@/components/ui/BaseModal.vue'; 
import BaseButtonGroup from '@/components/ui/BaseButtonGroup.vue'; 

// Props 
const props = defineProps({
  code: {
    type: String,
    required: true,
  },
  showModal: {
    type: Boolean,
    required: true,
  },
});

// Emits 
const emit = defineEmits(['doClose', 'doDeleteReservation']);

// Vuex Store 
const store = useStore();

// Computed Property 
const language = computed(() => store.state.user.LANG);
</script>


<style lang="scss" scoped>
@import "~@ridmv/web-themes/styles/modal";

.modal-cancel {
  .code {
    @extend %font-sans-bold;
    font-size: 1.25rem;
  }

  .app-button-group {
    button {
      margin-bottom: 1.125em;
      &:not(:last-child) {
        margin-right: 1em;
      }
      &.disabled {
        cursor: not-allowed;
        opacity: 0.7;
      }
    }
  }
}
</style>
